import React from 'react';

import {
  Box,
  Card,
  Table,
  Divider,
  CardHeader,
  TableContainer,
  Pagination,
  TextField,
  FormControlLabel,
  Switch,
} from '@mui/material';
import Scrollbar from 'src/components/Scrollbar';
import { TableHeadCustom } from './theme-components';

interface Props {
  isLoading: boolean;
  errorMessage?: string;
  tableLabels: { id: string; label: string; sortable?: boolean }[];
  title?: string;
  subheader?: string;
  tableHeaderComponent?: React.ReactNode;
  tableBodyComponent: React.ReactNode;
  currentPage: number;
  totalCount: number | undefined;
  itemsPerPage: number;
  orderBy?: string;
  isAscending?: boolean;
  onPageChangeHandler: (page: number) => void;
  onChangeItemsPerPageHandler: (itemsPerPage: number) => void;
  sortByHandler?: (sortBy: string) => void;
  ascendingOrderHandler?: (isAscending: boolean) => void;
}

export interface TableLabels {
  id: string;
  label: string;
  sortable?: boolean;
}

export const GenericPaginableTable: React.FC<Props> = ({
  isLoading,
  errorMessage,
  tableLabels,
  title = '',
  subheader = '',
  tableHeaderComponent: tableHeaerComponent,
  tableBodyComponent,

  itemsPerPage,
  isAscending,
  totalCount,
  currentPage,
  orderBy,
  sortByHandler,
  ascendingOrderHandler,
  onPageChangeHandler,
  onChangeItemsPerPageHandler,
  ...other
}) => {
  const numberOfPages = totalCount ? Math.ceil(totalCount / itemsPerPage) : 0;
  const [dense, setDense] = React.useState(true);

  const onPageChange = (_event: React.ChangeEvent<unknown>, page: number) => {
    onPageChangeHandler(page);
  };
  const onChangeDense = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDense(event.target.checked);
  };
  const onChangeItemsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChangeItemsPerPageHandler(parseInt(event.target.value, 10));
  };

  return (
    <Card {...other}>
      <CardHeader title={title} subheader={subheader} sx={{ mb: 3 }} />

      {tableHeaerComponent}

      <Scrollbar>
        <TableContainer sx={{ minWidth: 720 }} style={{ minHeight: dense ? '24rem' : '37.5rem' }}>
          <Table size={dense ? 'small' : 'medium'}>
            <TableHeadCustom
              order={isAscending ? 'asc' : 'desc'}
              orderBy={orderBy}
              headLabel={tableLabels}
              onSort={sortByHandler}
            />

            {tableBodyComponent}
          </Table>
        </TableContainer>
      </Scrollbar>

      <Divider />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          m: '1rem',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <TextField
            select
            value={itemsPerPage}
            onChange={onChangeItemsPerPage}
            size={'small'}
            SelectProps={{ native: true }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
          </TextField>
        </div>
        <Pagination
          page={currentPage}
          count={numberOfPages}
          variant="outlined"
          shape="rounded"
          onChange={onPageChange}
        />
        <FormControlLabel
          control={<Switch checked={dense} onChange={onChangeDense} />}
          label={'gusto'}
          style={{ marginLeft: '3rem' }}
        />
      </Box>
    </Card>
  );
};
